export default __webpack_public_path__ + "_/images/logos/egb-logo-affiliates-613a8c34d297980de3386f8b9f80174191a511d3c51aded3733132bf7c2a86bd.svg";